import { render } from "./Credits.vue?vue&type=template&id=008aec16&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"

import "./Credits.vue?vue&type=style&index=0&id=008aec16&scoped=true&lang=css"
import "./Credits.vue?vue&type=style&index=1&id=008aec16&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008aec16"]])

export default __exports__